export const PATHS = {
  // Public auth flows
  login: '/login',
  signup: '/signup',
  checkEmail: '/check-email',
  verifyEmail: '/verify-email',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',

  // Authenticated-but-not-yet-onboarded
  onboarding: '/onboarding',

  // Authenticated + onboarded
  dashboard: '/',
  aliases: '/aliases',
  aliasDetail: '/aliases/:id',
  activity: '/activity',
  senders: '/senders',
  billing: '/billing',
  settings: '/settings',
  notFound: '*',
} as const;

export type AppPath = (typeof PATHS)[keyof typeof PATHS];
